import React, { useCallback, useEffect, useState } from 'react'
import { DI, DIProps } from '../../../Core';
import { Card, Autocomplete, Box, Button, ChoiceList, Collapsible, EmptyState, InlineStack, Icon, Layout, Page, Text, TextField, BlockStack, Modal, FooterHelp, Link } from '@shopify/polaris';
import { ChevronDownMinor, ChevronUpMinor, CircleInformationMajor, ClipboardMinor, Column1Major, SearchMinor } from '@shopify/polaris-icons';
import './style.css';
import NoResultsFound from "../../../Asests/Images/NoResultsFound.png"
import { FaqIcon } from '../../../..../../Asests/svgIcon/icon';
import KnowledgeBaseSkeleton, { ChildKnowledgeBaseSekleton, KnowledgeBaseCardSkeleton } from './KnowledgeBaseSkeleton';
import { useDebounce } from '../useDebounce';
import KnowledgeBaseWelcome from './KnowledgeBaseWelcome';
import { isAdminLoggedIn } from '../Panel/index';
import { useTranslation } from 'react-i18next';
import { RenderHeadersAction } from '../Panel';

interface Props extends DIProps {
    showBackBtn: boolean;
    syncNecessaryInfo: () => void;
    syncConnectorInfo: (props: any, shop_url?: string | null, updateCurrentShop?: boolean, updateStepStatus?: React.Dispatch<React.SetStateAction<string>>) => void;
    syncProfileInfo: () => void;
    loginStatus: () => void;
    syncServices: () => void;
}
const KnowledgeBase = (props: Props) => {
    const { t } = useTranslation();
    const [search, setSearch] = useState<string>('');
    const [searchData, setSearchData] = useState([]);
    const [sections, setSections] = useState([]);
    const [subSections, setSubSections] = useState([]);
    const [knowledgeBases, setKnowledgeBases] = useState([]);
    const [knowledgeBase, setKnowledgeBase] = useState<any>({});
    const [loaders, setLoaders] = useState<{
        parent: boolean;
        child: boolean;
        child2: boolean;
        knowledge_base: boolean;
    }>({
        parent: false,
        child: false,
        child2: false,
        knowledge_base: false
    });
    const [searchloader, setSearchLoader] = useState<boolean>(false);
    const [collapsible, setCollapsible] = useState<string>('');
    const [collapsible2, setCollapsible2] = useState<string>('');
    const [feedback, setFeedback] = useState({ helpful: '', comment: '', loader: false })
    const [isMobile, setIsMobile] = useState(false);
    const [active, setActive] = useState(false);
    const handleChangeModal = useCallback(() => setActive(a => !a), [active]);
    const ref = React.useRef<any>();
    const [height, setHeight] = useState(0);
    const onLoad = () => {
        setHeight(ref.current?.contentWindow?.document?.body?.scrollHeight ?? 0);
    };

    //This is used to search knowledge bases
    const searchKnowledge = () => {
        setSearchLoader(true)
        props.di.GET('frontend/knowledgebase/getSuggestions', {
            query: search
        }).then((res) => {
            setSearchLoader(false)
            if (res.success) {
                setSearchData((res?.data ?? [])?.filter((a: any) => a.type === 'knowledge_base' && a.enableForClient))
            } else {
                props.error(t(res?.message) ?? t('Something went wrong'))
            }
        })
    }

    //getData for sections and knowledgeBases according to key and id and set them respectively
    const getData = async (key: 'parent' | 'child' | 'child2' | 'knowledge_base' = 'parent', id: string = '') => {
        setLoaders(loader => ({ ...loader, [key]: true }));
        let url = 'frontend/knowledgebase/getKnowledgeBases';
        await props.di.GET(url, {
            target_marketplace: 'amazon',
            count: 1000,
            doc_key: key === 'child' || key === 'child2' ? 'children' : key,
            ...id ? { id } : {}
        }).then((res: any) => {
            if (res.success && res?.data) {
                res.data = res?.data?.filter((row: any) => !!row?.enableForClient) ?? []
                const getSections = res.data?.filter((row: any) => (row.type === 'section' && !row.hasOwnProperty('parentSection_id') && !row.hasOwnProperty('parentSections'))) ?? [];
                const getSubSections = res.data?.filter((row: any) => (row.type === 'section' && row.hasOwnProperty('parentSection_id') && !row.hasOwnProperty('parentSections')));
                const getKnowledgeBases = res.data?.filter((row: any) => (row.type === 'knowledge_base' && row.hasOwnProperty('parentSection_id') && row.hasOwnProperty('parentSections')));
                if (getSections.length > 0) {
                    setSections(getSections);
                    setSubSections([]);
                    setKnowledgeBases([]);
                }
                if (getSubSections.length > 0 && id) {
                    setSubSections(getSubSections);
                    setKnowledgeBases([]);
                }
                if (getKnowledgeBases.length > 0 && id && (key === 'child2' || key === 'child')) {
                    setKnowledgeBases(res.data?.filter((row: any) => (row.type === 'knowledge_base' && row.hasOwnProperty('parentSection_id') && row.hasOwnProperty('parentSections'))))
                }
                if (getKnowledgeBases.length === 1 && key === 'knowledge_base' && id) {
                    setKnowledgeBase(getKnowledgeBases?.[0])
                }
                // let prepareSectionData = res?.data?.rows?.filter((row: any) => !row?.parentSection_id)
                // prepareSectionData = prepareSectionData?.map((prepData: any) => {
                //     let subSection = res?.data?.rows?.filter((row: any) => row?.parentSection_id === prepData?._id?.$oid && row.type === "section")
                //     subSection = subSection?.map((sub: any) => {
                //         let subSection = res?.data?.rows?.filter((row: any) => row?.parentSection_id === sub?._id?.$oid && row.type === "section")
                //         let knowledgeBase = res?.data?.rows?.filter((row: any) => row?.parentSection_id === sub?._id?.$oid && row.type === "knowledge_base")
                //         subSection = subSection.map((sub1: any) => {
                //             return { ...sub1, knowledgeBase: res?.data?.rows?.filter((row: any) => row?.parentSection_id === sub1?._id?.$oid && row.type === "knowledge_base") }
                //         })
                //         return {
                //             ...sub,
                //             knowledgeBase
                //         }
                //     })

                //     let knowledgeBase = res?.data?.rows?.filter((row: any) => row?.parentSection_id === prepData?._id?.$oid && row.type === "knowledge_base")
                //     if (subSection.length > 0) {
                //         return {
                //             ...prepData,
                //             subSection: subSection?.filter((a: any) => a?.knowledgeBase?.length > 0),
                //         }
                //     }
                //     else {
                //         return {
                //             ...prepData,
                //             knowledgeBase,
                //         }
                //     }
                // })
                // setSections(prepareSectionData.filter((a: any) => a?.knowledgeBase?.length > 0 || a?.subSection?.length > 0))
            } else {
                setSections([])
            }
            setLoaders(loader => ({ ...loader, [key]: false }));
        })
    }

    // smoothly scroll the webpage to a specific HTML element
    const scrollToElement = (element: any, offsetTop: number = 150) => {
        if (!element?.getBoundingClientRect()?.top) return;
        let y = element?.getBoundingClientRect()?.top + window.pageYOffset - offsetTop;
        window.scrollTo({ top: y, behavior: 'smooth' });
    }

    useEffect(() => {
        getData()
        if (props.match?.s_id) {
            getData('child', props.match?.s_id)
            setCollapsible(props.match?.s_id)
        }
        if (props.match?.sb_id) {
            getData('child2', props.match?.sb_id)
            setCollapsible2(props.match?.sb_id)
        }
        if (props.match?.kb_id) {
            getData('knowledge_base', props.match?.kb_id)
        }

        const handleResize = () => {
            setIsMobile(window.innerWidth < 1071); // set the breakpoint at 768px
        };

        window.addEventListener("resize", handleResize);
        handleResize(); // check the initial size
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const inputValue = useDebounce(search, 500);

    useEffect(() => {
        inputValue.trim().length > 2 && searchKnowledge()
    }, [inputValue]);

    // it decides what part of the URL to copy
    const copyUrlPath = () => {
        if (knowledgeBase?._id) {
            navigator.clipboard.writeText(window.location.href)
                .then(() => {
                    props.success(t('Knowledge Base URL has been successfully copied to clipboard'));
                })
                .catch(err => {
                    props.error(t('Failed to copy URL path'));
                });
        } else {
            let windowUrl = window.location.href;
            let startIndex = windowUrl.indexOf("knowledgeBase") + "knowledgeBase".length;
            let slashIndex = windowUrl.indexOf("/", startIndex);
            if (slashIndex == -1) {
                // startIndex = windowUrl.indexOf("knowledgeBase") + "knowledgeBase".length + 1;
                slashIndex = windowUrl.indexOf("knowledgeBase") + "knowledgeBase".length + 1;
            }
            navigator.clipboard.writeText(window.location.href.slice(0, slashIndex))
                .then(() => {
                    props.success(t('Knowledge Base URL has been successfully copied to clipboard'));
                })
                .catch(err => {
                    props.error(t('Failed to copy URL path'));
                });
        }
    };

    return <>
        <Page
            title={t('Knowledge Base')}
            subtitle={t('Your comprehensive guide to common queries and solutions')}
            backAction={props.location.state?.showBackBtn ? {
                onAction() {
                    props.history('../home')
                },
            } : undefined}
            primaryAction={
                <RenderHeadersAction {...props} show_only_lng_switcher />
            }
        >
            {loaders.parent && <KnowledgeBaseSkeleton />}
            {!loaders.parent && (sections?.length > 0 ?
                <BlockStack gap="400">
                    <Card roundedAbove='sm'>
                        <BlockStack gap="400">
                            <Text variant="headingMd" as="h6">
                                {t("How can we help you ?")}
                            </Text>
                            <Autocomplete
                                options={search?.trim()?.length > 2 ? searchData?.map((data: any) => {
                                    return {
                                        value: data?._id?.$oid,
                                        label: data?.title,
                                        id: data?._id?.$oid
                                    };
                                }) : []}
                                selected={[]}
                                onSelect={(selected) => {
                                    const kb: any = searchData?.find((data: any) => data?._id?.$oid === selected?.[0])
                                    setKnowledgeBase(kb);
                                    const parentSection: any = sections?.find((section: any) => section?.title === kb?.parentSections?.[0])
                                    parentSection && setCollapsible(parentSection?._id?.$oid);
                                    if (kb.parentSections?.length > 1 && parentSection?.subSection) {
                                        const subParentSection: any = parentSection?.subSection?.find((section: any) => section?.title === kb?.parentSections?.[1])
                                        subParentSection && setCollapsible2(subParentSection?._id?.$oid)
                                    }
                                    setSearch('');
                                    setSearchData([])
                                }}
                                loading={searchloader}
                                emptyState={search?.trim()?.length > 2 ?
                                    <React.Fragment>
                                        <InlineStack gap="400" align="center">
                                            <div>
                                                <Icon source={SearchMinor} />
                                            </div>
                                            <div style={{ textAlign: 'center' }}>
                                                <Text as='span'>{t("Could not find any results")}</Text>
                                            </div>
                                        </InlineStack>
                                    </React.Fragment>
                                    : false}
                                textField={<Autocomplete.TextField
                                    onChange={(e) => {
                                        e?.trim()?.length > 2 ? setSearchLoader(true) : setSearchLoader(false);
                                        setSearch(e)
                                    }}
                                    label=""
                                    prefix={<Icon source={SearchMinor} tone="base" />}
                                    placeholder={t("Search for your query here")}
                                    autoComplete="off"
                                    value={search}
                                    clearButton
                                    onClearButtonClick={() => { setSearch(''); setSearchData([]) }}
                                />}
                            />
                        </BlockStack>
                    </Card>
                    <Card roundedAbove='sm'>
                        <BlockStack gap="800">
                            <InlineStack align='space-between'>
                                <Text variant="headingMd" as="h6">
                                    {t("Browse Category")}
                                </Text>
                                <Button variant='plain' onClick={() => { copyUrlPath() }} icon={ClipboardMinor}>
                                    {t("Copy link to clipboard")}
                                </Button>
                            </InlineStack>
                            <Layout>
                                <Layout.Section variant='oneThird'>
                                    <BlockStack gap='0'>
                                        {sections.map((section1: any, sec_idx: number) => {
                                            let collapsible_open1 = collapsible.includes(section1._id.$oid)
                                            return <BlockStack gap="200" key={sec_idx}>
                                                <div className='Custom__Box--FirstStep'>
                                                    <div className={collapsible_open1 ? 'collapsible_open' : ''} onClick={() => {
                                                        !collapsible_open1 && getData('child', section1?._id?.$oid)
                                                        setSubSections([]);
                                                        setKnowledgeBases([]);
                                                        setKnowledgeBase({});
                                                        setCollapsible(collapsible_open1 ? '' : section1._id.$oid)
                                                        setCollapsible2('')
                                                        setFeedback({ comment: '', helpful: '', loader: false });
                                                    }} style={{ cursor: 'pointer' }}>
                                                        <Box padding="500">

                                                            <InlineStack align='space-between' blockAlign='center' wrap={false}>
                                                                <Text variant="headingMd" as="h6" tone={collapsible_open1 ? 'success' : undefined} >{section1.title}</Text>
                                                                <div><Icon source={collapsible_open1 ? ChevronUpMinor : ChevronDownMinor} /></div>
                                                            </InlineStack>

                                                        </Box>
                                                    </div>
                                                </div>
                                                <Collapsible id={section1._id.$oid} open={collapsible_open1} transition={{ duration: "500ms", timingFunction: "ease-in-out" }}>
                                                    {loaders.child ? <ChildKnowledgeBaseSekleton /> :
                                                        <BlockStack gap="100">
                                                            <BlockStack gap='0'>
                                                                {subSections?.length === 0 && knowledgeBases?.map((knowledgeBase1: any, idx1: number) => {
                                                                    return <div key={idx1} className={`Custom__Ans--Box ${knowledgeBase1?._id?.$oid === knowledgeBase?._id?.$oid ? 'Custom__Ans--BoxSelected' : undefined}`} onClick={() => {
                                                                        console.log(props, "fdjcxb");
                                                                        console.log(window.location, props, "location");

                                                                        if (props.location.pathname.includes('/panel/user')) props.history(`/panel/user/knowledgeBase/${section1._id.$oid}/${knowledgeBase1?._id?.$oid}`)
                                                                        else props.history(`/panel/knowledgeBase/${section1._id.$oid}/${knowledgeBase1?._id?.$oid}`)
                                                                        // props.history(`/panel/knowledgeBase/${section1._id.$oid}/${knowledgeBase1?._id?.$oid}`)

                                                                        getData('knowledge_base', knowledgeBase1?._id?.$oid)
                                                                        knowledgeBase?._id?.$oid !== knowledgeBase1?._id?.$oid && setFeedback({ comment: '', helpful: '', loader: false });
                                                                        scrollToElement(document.body)
                                                                        isMobile && handleChangeModal()
                                                                    }}>
                                                                        <InlineStack gap="400" blockAlign='start' wrap={false} >
                                                                            <FaqIcon />
                                                                            <Text variant="headingMd" as="h6" fontWeight="regular">
                                                                                {knowledgeBase1.title}
                                                                            </Text>
                                                                        </InlineStack>
                                                                    </div>
                                                                })}
                                                            </BlockStack>
                                                            {subSections?.length > 0 && subSections?.map((section2: any, sec_idx1: number) => {
                                                                let collapsible_open2 = collapsible2.includes(section2._id.$oid)
                                                                return <React.Fragment key={section2._id.$oid}>
                                                                    <div className='Custom__Box--SecondStep'>
                                                                        <div className={collapsible_open2 ? 'collapsible_open2' : ''} onClick={() => {
                                                                            !collapsible_open2 && getData('child2', section2?._id?.$oid)
                                                                            setKnowledgeBases([]);
                                                                            setKnowledgeBase({});
                                                                            setCollapsible2(collapsible_open2 ? '' : section2._id.$oid)
                                                                            setFeedback({ comment: '', helpful: '', loader: false });
                                                                        }} style={{ cursor: 'pointer' }}>
                                                                            <Box padding="300">

                                                                                <InlineStack align='space-between' blockAlign='center' wrap={false}>
                                                                                    <Text variant="headingMd" as="h6" fontWeight="medium" tone={collapsible_open2 ? 'success' : undefined} >{section2.title}</Text>
                                                                                    <div><Icon source={collapsible_open2 ? ChevronUpMinor : ChevronDownMinor} /></div>
                                                                                </InlineStack>
                                                                            </Box>
                                                                        </div>
                                                                    </div>
                                                                    <Collapsible id={section2._id.$oid} open={collapsible_open2} transition={{ duration: "500ms", timingFunction: "ease-in-out" }} expandOnPrint>
                                                                        {loaders.child2 ? <ChildKnowledgeBaseSekleton /> :
                                                                            <BlockStack gap='0'>
                                                                                {knowledgeBases?.map((knowledgeBase2: any, idx2: number) => {
                                                                                    return <div className={`Custom__Ans--Box ${knowledgeBase2?._id?.$oid === knowledgeBase?._id?.$oid ? 'Custom__Ans--BoxSelected' : undefined}`} key={idx2} onClick={() => {
                                                                                        if (props.location.pathname.includes('/panel/user')) props.history(`/panel/user/knowledgeBase/${section1._id.$oid}/${section2._id.$oid}/${knowledgeBase2?._id?.$oid}`)
                                                                                        else props.history(`/panel/knowledgeBase/${section1._id.$oid}/${section2._id.$oid}/${knowledgeBase2?._id?.$oid}`)
                                                                                        // props.history(`/panel/knowledgeBase/${section1._id.$oid}/${section2._id.$oid}/${knowledgeBase2?._id?.$oid}`)

                                                                                        getData('knowledge_base', knowledgeBase2?._id?.$oid);
                                                                                        setKnowledgeBase({})
                                                                                        knowledgeBase?._id?.$oid !== knowledgeBase2?._id?.$oid && setFeedback({ comment: '', helpful: '', loader: false });
                                                                                        scrollToElement(document.body)
                                                                                        isMobile && handleChangeModal()
                                                                                    }}>
                                                                                        <InlineStack gap="400" blockAlign='start' wrap={false}>
                                                                                            <FaqIcon />
                                                                                            <Text variant="headingMd" as="h6" fontWeight="regular">
                                                                                                {knowledgeBase2.title}
                                                                                            </Text>
                                                                                        </InlineStack>
                                                                                    </div>
                                                                                })}
                                                                            </BlockStack>}
                                                                    </Collapsible>
                                                                </React.Fragment>
                                                            })}
                                                        </BlockStack>}
                                                </Collapsible>
                                            </BlockStack>
                                        })}
                                    </BlockStack>
                                </Layout.Section>
                                <Layout.Section>
                                    <BlockStack gap='400'>
                                        {isMobile && knowledgeBase?._id?.$oid ? (
                                            <Modal
                                                open={active}
                                                onClose={handleChangeModal}
                                                title={t(knowledgeBase?.title)}
                                                size='large'
                                            >
                                                <Modal.Section>
                                                    {loaders?.knowledge_base ? <KnowledgeBaseCardSkeleton /> : <BlockStack gap="500">
                                                        <iframe
                                                            ref={ref}
                                                            onLoad={onLoad}
                                                            id="knowledgeBase"
                                                            width="100%"
                                                            height={height + 50}
                                                            srcDoc={knowledgeBase?.walkthrough}
                                                            scrolling="no"
                                                            frameBorder="0"
                                                            style={{
                                                                // maxWidth: 640,
                                                                width: "100%",
                                                                overflow: "auto",
                                                            }}
                                                        ></iframe>
                                                        <Card>
                                                            <BlockStack gap="400">
                                                                <InlineStack gap="500" blockAlign='center'>
                                                                    <Text variant="headingSm" as="h6">
                                                                        {t("Was this information helpful to you ?")}
                                                                    </Text>
                                                                    <InlineStack gap="400">
                                                                        <Button
                                                                            onClick={() => { setFeedback(a => ({ ...a, helpful: 'yes' })); }}
                                                                            variant={feedback.helpful === 'yes' ? 'primary' : undefined}
                                                                        >Yes</Button>
                                                                        <Button
                                                                            onClick={() => { setFeedback(a => ({ ...a, helpful: 'no' })); }}
                                                                            variant={feedback.helpful === 'no' ? 'primary' : undefined}
                                                                        >No</Button>
                                                                    </InlineStack>
                                                                </InlineStack>
                                                                <TextField
                                                                    label={t("Please comment your reviews")}
                                                                    value={feedback.comment}
                                                                    onChange={(s) => { setFeedback(a => ({ ...a, comment: s })); }}
                                                                    multiline={4}
                                                                    autoComplete="off"
                                                                />
                                                                <InlineStack align='end'>
                                                                    <Button variant="primary" onClick={() => {
                                                                        let review = [...knowledgeBase?.review ?? []]
                                                                        if (knowledgeBase?.review && knowledgeBase?.review?.find((a: any) => a?.client === (props.di.globalState.get('shop') ?? "Unknown"))) {
                                                                            review.splice(knowledgeBase?.review?.find((a: any) => a?.client === props.di.globalState.get('shop') ?? "Unknown"), 1)
                                                                        }
                                                                        review.unshift(
                                                                            {
                                                                                helpful: feedback.helpful,
                                                                                feedback: feedback.comment,
                                                                                client: props.di.globalState.get('shop') ?? "Unknown"
                                                                            }
                                                                        )
                                                                        setFeedback(a => ({ ...a, loader: true }));
                                                                        const data = {
                                                                            "_id": knowledgeBase?._id?.$oid,
                                                                            "created_by": knowledgeBase?.created_by ?? '',
                                                                            "created_on": knowledgeBase?.created_on ?? "",
                                                                            "description": knowledgeBase?.description ?? "",
                                                                            "devDetails": knowledgeBase?.devDetails ?? [],
                                                                            "enableForClient": knowledgeBase?.enableForClient ?? false,
                                                                            "links": knowledgeBase?.links ?? [],
                                                                            "tags": knowledgeBase?.tags ?? [],
                                                                            "target_marketplace": "amazon",
                                                                            "title": knowledgeBase?.title ?? '',
                                                                            "type": "knowledge_base",
                                                                            "videos": knowledgeBase?.videos ?? "",
                                                                            "walkthrough": knowledgeBase?.walkthrough ?? "",
                                                                            review
                                                                        }
                                                                        props.di.POST('frontend/knowledgebase/saveDetails', data).then((res) => {
                                                                            if (res?.success) {
                                                                                props?.success(t('Thank you for your feedback!'));
                                                                            }
                                                                            setFeedback({ comment: '', helpful: '', loader: false });
                                                                        })
                                                                    }}>{t("Submit response")}</Button>
                                                                </InlineStack>
                                                            </BlockStack>
                                                        </Card>
                                                    </BlockStack>}
                                                </Modal.Section>
                                            </Modal>
                                        ) : loaders?.knowledge_base ? <KnowledgeBaseCardSkeleton /> : (
                                            knowledgeBase?.walkthrough ?
                                                <Card>
                                                    <iframe
                                                        ref={ref}
                                                        onLoad={onLoad}
                                                        id="knowledgeBase"
                                                        width="100%"
                                                        height={height + 50}
                                                        srcDoc={knowledgeBase?.walkthrough}
                                                        frameBorder="0"
                                                        scrolling='no'
                                                        style={{
                                                            width: "100%",
                                                            overflow: "auto",
                                                        }}
                                                    ></iframe>
                                                </Card> :
                                                !isMobile && <KnowledgeBaseWelcome />
                                        )}
                                        {!isMobile && knowledgeBase?._id?.$oid && !loaders.knowledge_base && <Card>
                                            <BlockStack gap="400">
                                                <InlineStack gap="500" blockAlign='center'>
                                                    <Text variant="headingSm" as="h6">
                                                        {t("Was this information helpful to you ?")}
                                                    </Text>
                                                    <InlineStack gap="400">
                                                        <Button
                                                            // icon={ThumbsUpMinor}
                                                            onClick={() => { setFeedback(a => ({ ...a, helpful: 'yes' })); }}
                                                            variant={feedback.helpful === 'yes' ? 'primary' : undefined}
                                                        >{t("Yes")}</Button>
                                                        <Button
                                                            // icon={ThumbsDownMinor}
                                                            onClick={() => { setFeedback(a => ({ ...a, helpful: 'no' })); }}
                                                            variant={feedback.helpful === 'no' ? 'primary' : undefined}
                                                        >{t("No")}</Button>
                                                    </InlineStack>
                                                </InlineStack>
                                                <TextField
                                                    label={t("Please comment your reviews")}
                                                    value={feedback.comment}
                                                    onChange={(s) => { setFeedback(a => ({ ...a, comment: s })); }}
                                                    multiline={4}
                                                    autoComplete="off"
                                                />
                                                <InlineStack align='end'>
                                                    <Button variant="primary" loading={feedback.loader} onClick={() => {
                                                        let review = [...knowledgeBase?.review ?? []]
                                                        if (knowledgeBase?.review && knowledgeBase?.review?.find((a: any) => a?.client === (props.di.globalState.get('shop') ?? "Unknown"))) {
                                                            review.splice(knowledgeBase?.review?.find((a: any) => a?.client === props.di.globalState.get('shop') ?? "Unknown"), 1)
                                                        }
                                                        review.unshift(
                                                            {
                                                                helpful: feedback.helpful,
                                                                feedback: feedback.comment,
                                                                client: props.di.globalState.get('shop') ?? "Unknown"
                                                            }
                                                        )
                                                        setFeedback(a => ({ ...a, loader: true }));
                                                        const data = {
                                                            "_id": knowledgeBase?._id?.$oid,
                                                            "created_by": knowledgeBase?.created_by ?? '',
                                                            "created_on": knowledgeBase?.created_on ?? "",
                                                            "description": knowledgeBase?.description ?? "",
                                                            "devDetails": knowledgeBase?.devDetails ?? [],
                                                            "enableForClient": knowledgeBase?.enableForClient ?? false,
                                                            "links": knowledgeBase?.links ?? [],
                                                            "tags": knowledgeBase?.tags ?? [],
                                                            "target_marketplace": "amazon",
                                                            "title": knowledgeBase?.title ?? '',
                                                            "type": "knowledge_base",
                                                            "videos": knowledgeBase?.videos ?? "",
                                                            "walkthrough": knowledgeBase?.walkthrough ?? "",
                                                            review
                                                        }
                                                        props.di.POST('frontend/knowledgebase/saveDetails', data).then((res) => {
                                                            props?.success('Thank you for your feedback!');
                                                            setFeedback(a => ({ ...a, loader: false }));
                                                        })
                                                    }}>{t("Submit response")}</Button>
                                                </InlineStack>
                                            </BlockStack>
                                        </Card>}
                                    </BlockStack>
                                </Layout.Section>
                            </Layout>
                        </BlockStack>
                    </Card >
                </BlockStack >
                :
                <Card>
                    <EmptyState
                        image={NoResultsFound}
                        heading={t("No Knowldge Base found!")}
                    />
                </Card>
            )}
            <FooterHelp>
                <InlineStack align="center" gap="100">
                    <div>
                        <Icon
                            source={CircleInformationMajor}
                            tone="info"
                        />
                    </div>
                    {t("Learn more about")}
                    <Link target='_blank' url="https://docs.cedcommerce.com/shopify/multi-account-amazon-cedcommerce/?section=introduction-5">
                        {t("CedCommerce Amazon Channel,")}
                    </Link><Link target='_blank' url='https://amazon-sales-channel-app-backend.cifapps.com/Cedcommerce_Privacy_Statement.pdf'>
                        {t("Terms & Conditions")}
                    </Link>{t("and")}<Link target='_blank' url='https://amazon-sales-channel-app-backend.cifapps.com/Data_Privacy_Rights.pdf'>
                        {t("Data Privacy Rights.")}
                    </Link> {t("Need Help?")}<Link target='_blank'
                        url={`https://admin.shopify.com/apps${process.env.REACT_APP_SHOPIFY_APP_BASE}/panel/user/support`}>
                        {t("Get Support")}
                    </Link>{t("or")}<Link target='_blank' url="https://calendly.com/cedcommerce-awe-sales/sales" >
                        {t("Book a Call")}
                    </Link>
                </InlineStack>
            </FooterHelp>
        </Page >
    </>;
}

export default DI(KnowledgeBase);

